import axios from 'axios';
import { request_mutations, request_state } from '../utils/store';
import { SPACE_TEAMS_LIST, SPACE_TEAMS_DETAIL } from '../api';
import { auth } from '../utils/requests';

export default {
    namespaced: true,
    state: { list: request_state(), create: request_state(), remove: request_state() },
    mutations: {
        ...request_mutations('space_teams_list', 'list'),
        ...request_mutations('create_space_team', 'create'),
        ...request_mutations('remove_space_team', 'remove'),
    },
    actions: {
        list({ commit }, { space_id }) {
            commit('space_teams_list_loading');
            return new Promise((resolve) => {
                axios.get(SPACE_TEAMS_LIST.replace('{space_id}', space_id), auth()).then((response) => {
                    commit('space_teams_list_success', response.data);
                    resolve();
                }).catch(error => commit('space_teams_list_error', error.response ? error.response.data : {}));
            });
        },
        create({ commit }, { space_id, team_id, role }) {
            const url = SPACE_TEAMS_LIST.replace('{space_id}', space_id);
            commit('create_space_team_loading');

            return new Promise((resolve) => {
                axios.post(url, { team: team_id, role }, auth()).then((response) => {
                    commit('create_space_team_success', response.data);
                    resolve();
                }).catch(error => commit('create_space_team_error', error.response ? error.response.data : {}));
            });
        },
        remove({ commit }, { space_id, team_id }) {
            const url = SPACE_TEAMS_DETAIL.replace('{space_id}', space_id).replace('{team_id}', team_id);
            commit('remove_space_team_loading');
            return new Promise((resolve) => {
                axios.delete(url, auth()).then((response) => {
                    commit('remove_space_team_success', response.data);
                    resolve();
                }).catch(error => commit('remove_space_team_error', error.response ? error.response.data : {}));
            });
        },
    },
    getters: {
        as_teams: (state) => {
            if (!state.list.data.results) {
                return [];
            }
            return state.list.data.results.map(item => item.team);
        },
    },
};
